import { useEffect, useState } from 'react';
import { Alert, AlertIcon, Button, Flex, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, Tbody, Td, Th, Thead, Tr, Text } from '@chakra-ui/react';
import { axiosInstance } from '../../api/init';

type Entry = { _id: string; createdAt: string; client_id?: string; login?: string; method: string; path: string; status: number; durationMs: number };
const MAX_ACTIVITY_LOG_ROWS = 10000;

const ActivityLogs = ({ onClose }: { onClose: () => void }) => {
  const [rows, setRows] = useState<Entry[]>([]);
  const [search, setSearch] = useState('');
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const load = async (before?: string) => {
    setLoading(true);
    setError('');
    try {
      const response = await axiosInstance.get('/api/activity-logs', { params: { search, before } });
      const nextRows = before ? [...rows, ...response.data.data] : response.data.data;
      const limitedRows = nextRows.slice(0, MAX_ACTIVITY_LOG_ROWS);
      setRows(limitedRows);
      setHasMore(response.data.hasMore && limitedRows.length < MAX_ACTIVITY_LOG_ROWS);
    } catch {
      setError('Impossible de charger le journal.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { void load(); }, []);
  return (
    <Modal isOpen onClose={onClose} size='full'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Journal d’activité</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowX='auto' pb={6}>
          <Text mb={3}>Les 10 000 requêtes API les plus récentes sont conservées. La recherche porte sur toutes les colonnes du journal.</Text>
          <Flex gap={3} mb={4} flexWrap='wrap'>
            <Input aria-label='Recherche globale' placeholder='Rechercher dans le journal' value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') void load(); }} maxW='320px' isDisabled={loading} />
            <Button isLoading={loading} onClick={() => void load()}>Rechercher</Button>
          </Flex>
          {error && <Alert status='error'><AlertIcon />{error}</Alert>}
          <Table size='sm'>
            <Thead><Tr>{['Date', 'Société', 'Utilisateur', 'Méthode', 'Action / chemin', 'Statut HTTP', 'Durée'].map(title => <Th key={title}>{title}</Th>)}</Tr></Thead>
            <Tbody>{rows.map(row => <Tr key={row._id}>
              <Td whiteSpace='nowrap'>{new Date(row.createdAt).toLocaleString('fr-FR')}</Td>
              <Td>{row.client_id || 'Non identifiée'}</Td><Td>{row.login || 'Non authentifié'}</Td>
              <Td>{row.method}</Td><Td wordBreak='break-all'>{row.path}</Td>
              <Td>{row.status}</Td><Td>{row.durationMs} ms</Td>
            </Tr>)}</Tbody>
          </Table>
          {!loading && !error && !rows.length && <Text mt={4}>Aucune activité enregistrée pour ces filtres.</Text>}
          {hasMore && <Button mt={4} isLoading={loading} onClick={() => void load(rows[rows.length - 1]?._id)}>Charger la suite</Button>}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default ActivityLogs;
